module.exports = __webpack_public_path__ + "static/media/logikeyboard@2x.57ceb58d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/accesories/logikeyboard@2x.png
// module id = 327
// module chunks = 0